import React from 'react';
import StatBit from './stat-bit';

const StatRow = (props) =>
  <div className="stats-row">
    {props.stats.map((stat, idx) =>
      <StatBit key={idx} statNumber={stat.value} statLabel={stat.label} />
    )}
  </div>
;

export default StatRow;
